<hf-custom-spinner *ngIf="isLoading" [darkTheme]="false"></hf-custom-spinner>

<div *ngIf="!isLoading" class="container">
  <div *ifMedia="'desktop'" class="navigation">
    <hf-protection-dashboard-fact-find-navigation [applicants]="data.applicants">
    </hf-protection-dashboard-fact-find-navigation>
  </div>

  <div class="view">
    <div class="mobile-sticky">
      <h2>Fact Find</h2>
      <div class="header">
        <hf-fact-find-status-banner [status]="data.factFindStatus"></hf-fact-find-status-banner>

        <div class="desktop-buttons">
          <ng-container *ngIf="data.factFindStatus !== 'APPROVED'">
            <hf-custom-button
              type="button"
              [class]="'button-secondary btn-lrg'"
              [iconPos]="'right'"
              [icon]="'edit'"
              label="Edit"
              (click)="onEditClicked()"
            ></hf-custom-button>
            <hf-custom-button
              [disabled]="!isReturnButtonEnabled"
              type="button"
              [class]="'button-grey btn-lrg'"
              label="Return"
              (click)="onReturnClicked()"
            ></hf-custom-button>
            <hf-custom-button
              [disabled]="!isApproveButtonEnabled"
              type="button"
              [class]="'button-primary btn-lrg'"
              label="Approve"
              (click)="onApproveClicked()"
            ></hf-custom-button>
          </ng-container>

          <hf-custom-button
            *ngIf="isReactivateButtonEnabled"
            type="button"
            [class]="'button-primary btn-lrg'"
            label="Reactivate"
            (click)="onReactivateClicked()"
          ></hf-custom-button>
        </div>
      </div>
    </div>

    <hf-protection-dashboard-fact-find-applicant
      *ngFor="let applicant of data?.applicants"
      [data]="applicant"
      [factFindStatus]="data.factFindStatus"
      (buttonClick)="onSectionButtonClicked($event, applicant.applicant.id)"
      id="applicant-{{ applicant.applicant.id }}"
    ></hf-protection-dashboard-fact-find-applicant>
  </div>
</div>
